import { queryKeys } from './useQueryContract'
import { useFetchContract } from './useFetchContract'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { queryKeys as balanceQueryKeys } from '../balance/useQueryBalance'
import { useMutationContractSignature } from './signature/useMutationContractSignature'

const create = () => {
  const { create } = useFetchContract()
  const queryClient = useQueryClient()
  const { activeWorkspaceId } = useAuth()
  const { cancelRelationalRequestsByType, invalidateRelationalCacheDataByType } = useQueryClientUtils()

  return useMutation({
    mutationFn: create,
    onMutate: () => {
      queryClient.cancelQueries(balanceQueryKeys.all({ workspaceId: activeWorkspaceId as MaybeRef<string> }))
      cancelRelationalRequestsByType('contract')
    },
    onSuccess: () => {
      queryClient.invalidateQueries(balanceQueryKeys.all({ workspaceId: activeWorkspaceId as MaybeRef<string> }))
      invalidateRelationalCacheDataByType('contract')
    },
  })
}

const createLegacy = () => {
  const { createLegacy } = useFetchContract()
  const queryClient = useQueryClient()
  const { activeWorkspaceId } = useAuth()

  return useMutation({
    mutationFn: createLegacy,
    onMutate: () => {
      queryClient.cancelQueries(balanceQueryKeys.all({ workspaceId: activeWorkspaceId as MaybeRef<string> }))
    },
    onSuccess: () => {
      queryClient.invalidateQueries(balanceQueryKeys.all({ workspaceId: activeWorkspaceId as MaybeRef<string> }))
    },
  })
}

const update = () => {
  const { update } = useFetchContract()
  const queryClient = useQueryClient()
  const { invalidateRelationalCacheDataByType, cancelRelationalRequestsByType } = useQueryClientUtils()

  return useMutation({
    mutationFn: update,
    onMutate: ({ contractId }) => {
      queryClient.cancelQueries(queryKeys.byId({ id: contractId }))
      cancelRelationalRequestsByType('contract')
    },
    onSettled: () => {
      invalidateRelationalCacheDataByType('contract')
    },
    onSuccess: (responseData, { contractId }) => {
      queryClient.setQueryData(
        queryKeys.byId({ id: contractId }).queryKey,
        responseData,
      )
    },
    onError: (_, { contractId }) => {
      queryClient.invalidateQueries(queryKeys.byId({ id: contractId }))
    },
  })
}

const startStrongSigning = () => {
  const { startStrongSigning } = useFetchContract()

  return useMutation({
    mutationFn: startStrongSigning,
    // Cache invalidation isn't required because the contract doesn't change immediately upon strong signing.
  })
}

export const useMutationContract = {
  create,
  createLegacy,
  update,
  startStrongSigning,
  signature: useMutationContractSignature,
}
